import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface ConfirmDialogData {
	title: string;
	message: string;
	note?: string;
	cancelText?: string;
	confirmText?: string;
	confirmStyle?: string;
	warningNote?: boolean;
	dialogTitleId?: string;
}
export interface ConfirmDialogConfig {
	disableClose?: boolean;
}

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	standalone: false
})
export class ConfirmDialogComponent {
	public constructor (
		public dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
	) {
		this.data.dialogTitleId ??= ConfirmDialogComponent.getDialogTitleId();
	}

	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<ConfirmDialogData>
	): MatDialogRef<ConfirmDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? ConfirmDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, ConfirmDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `confirm-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public close () {
		this.dialogRef.close(null);
	}

	public cancel () {
		this.dialogRef.close(false);
	}

	public confirm () {
		this.dialogRef.close(true);
	}
}
